import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useCheckDisableStartDemoBtn = () => {
  const settingGlobal = useSelector((state) => state.settingGlobalReducer.settingGlobal);

  return useMemo(() => settingGlobal?.IsStartSessionDisabled ?? false, [settingGlobal]);
};

export default useCheckDisableStartDemoBtn;